import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["className", "color", "size", "data-testid"];
var TargetLogo = function TargetLogo(props) {
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'red' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    dataTestId = props['data-testid'],
    otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('TargetLogo', otherProps);
  var finalClasses = classnames('C-TargetLogo', _defineProperty(_defineProperty({}, "--size-".concat(size), size), "--color-".concat(color), color), className);
  var finalSVGClasses = classnames('C-TargetLogo__element', _defineProperty({}, "--color-".concat(color), color));
  return /*#__PURE__*/React__default.createElement("svg", {
    className: finalClasses,
    "data-testid": dataTestId,
    viewBox: "0 0 33.9 34",
    role: "img",
    focusable: "false",
    "aria-label": "Target Logo"
  }, /*#__PURE__*/React__default.createElement("path", {
    className: finalSVGClasses,
    d: "M33,17c0,8.9-7.2,16.1-16.1,16.1S0.8,25.9,0.8,17S8,0.9,16.9,0.9S33,8.1,33,17z M16.9,6.3 C11,6.3,6.2,11.1,6.2,17S11,27.7,16.9,27.7S27.6,22.9,27.6,17S22.8,6.3,16.9,6.3z"
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: finalSVGClasses,
    cx: "16.9",
    cy: "17",
    r: "5.4"
  }));
};
TargetLogo.displayName = 'TargetLogo';

export { TargetLogo as default };
